module.exports = __webpack_public_path__ + "img/logo.33c6c5b5.png";